import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  gutter: {
    marginTop: "-2rem",
    backgroundColor: "black",
  },
  container: {
    padding: "2rem 2rem",
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "white",
    textAlign: "center",
  },
  items: {
    padding: "1.5rem",
    fontSize: "100%",
  },
  bottomGutter: {
    display: "flex",
    justifyContent: "center",
    color: "white",
    opacity: "0.7",
  },
});
const Gutter = () => {
  const classes = useStyles();
  return (
    <div className={classes.gutter}>
      <Grid container className={classes.container}>
        <Grid item xs={4} className={classes.gridItem}>
          <Typography variant="h5" className={classes.items}>
            Contact
          </Typography>
          <Typography variant="body1">999-999-9999</Typography>
          <Typography variant="body1">1092 Almond Avenue</Typography>
          <Typography variant="body1">New York</Typography>
          <Typography variant="body1">United States</Typography>
        </Grid>
        <Grid item xs={4} className={classes.gridItem}>
          <Typography variant="h5" className={classes.items}>
            Resources
          </Typography>
          <Typography variant="body1">About us</Typography>
          <Typography variant="body1">Terms and Agreement</Typography>
          <Typography variant="body1">Our Community</Typography>
        </Grid>
        <Grid item xs={4} className={classes.gridItem}>
          <Typography variant="h5" className={classes.items}>
            Team
          </Typography>
          <Typography variant="body1">Jared Logan</Typography>
          <Typography variant="body1">Brandon Rorie</Typography>
          <Typography variant="body1">Muhammad Rajput</Typography>
        </Grid>
      </Grid>
      <div className={classes.bottomGutter}>
        <Typography variant="subtitle1">
          2020 license agreenment. FPS name is reserved.
        </Typography>
      </div>
    </div>
  );
};

export default Gutter;
